import React from "react";
import Box from "@mui/material/Box";
import { CentreData } from "types/models/support/SupportApp";
import { Fonts } from "shared/constants/AppEnums";



interface CentreProps {
  centre: CentreData;
}

const CentreHeader: React.FC<CentreProps> = ({ centre }) => {
 

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        flexDirection: { xs: "column", sm: "row" },
        pb: 5,
        mb: 2,
        borderBottom: "1px solid #E5E4EA",
      }}
    >
      <Box
        sx={{
          flex: 1,
        }}
      >
        <Box
          component="h3"
          sx={{
            color: "text.primary",
            fontWeight: Fonts.BOLD,
            fontSize: 16,
            mb: 1,
          }}
        >
          {centre ? "Edit Centre" : "Add New Centre"}
        </Box>
       
      </Box>
    </Box>
  );
};

export default CentreHeader;
